import { render } from "./PaymentReceiptDetailTabsPanel.vue?vue&type=template&id=be153fa8"
import script from "./PaymentReceiptDetailTabsPanel.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptDetailTabsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__